function App() {}
App.prototype.init = function () {
    var cart = new Cart();
    cart.initAddToCart();
    cart.initRemoveToCart();
    var filter = new Filter();
    filter.initAll();
    

    var imageShopify = new ImageShopify();
    imageShopify.initAll();
    var countDownShopify = new CountDownShopify();
    countDownShopify.initAll();
}